import axios from 'axios';
import { isAxiosNetworkError } from 'utils/networkError.utils';

export const apiRequestHandler = (props) => {
  const {
    endpoint,
    method,
    setLoader = null,
    onSuccess = null,
    onError = null,
    callBack = null,
    payload = null,
    responseType = 'json',
  } = props;

  setLoader && setLoader(true);
  axios({
    method,
    url: endpoint,
    data: payload,
    responseType,
  })
    .then((response) => {
      onSuccess && onSuccess(response.data);
    })
    .catch((err) => {
      onError && onError(err);
      if (!isAxiosNetworkError(err)) {
        console.error(`API ERROR: (${endpoint})`, err);
      }
    })
    .finally(() => {
      callBack && callBack();
      setLoader && setLoader(false);
    });
};

export const apiHost = process.env.REACT_APP_HOST_URL;
